import React from 'react'
import { Button } from 'modules/core/components'

const CreateButton = ({ disabled, onClick }) => {
  return <Button.Primary onClick={onClick} disabled={disabled} title="CONFIG_ROLES_CREATE_ACTION" />
}

export default CreateButton
